<template>
  <v-card class="pa-2 report-card">
    <v-card-title class="d-flex justify-space-between"
      ><span
        >1.16 - {{ $t('Solicitações por Oficina') }}
        <v-tooltip color="white" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="black" dark v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span class="black--text">{{
            $t(
              'Apresenta o número de ordens de serviço solicitadas para cada oficina do hospital no período filtrado.'
            )
          }}</span>
        </v-tooltip></span
      >
      <v-btn
        @click="requestExcel"
        depressed
        small
        class="secondary-button mr-1"
      >
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn></v-card-title
    >

    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="items.length == 0">
      {{ $t('Nenhuma ordem encontrada') }}
    </v-alert>
    <v-card-text v-else>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <PieChart :chartData="chartData" :options="options" />
        </v-col>
      </v-row>

      <div class="wrapper">
        <v-data-table
          :loading="loading"
          :loading-text="$t('Carregando...')"
          :no-data-text="$t('Nenhum setor encontrado')"
          :headers="headers"
          :items="items"
          class="main-table"
          hide-default-footer
          hide-default-header
          dense
          :header-props="headerProps"
          :items-per-page="items.length"
          :mobile-breakpoint="0"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.value"
                  class="text-center"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.workshopType`]="{ item }">
            {{
              item.workshopType != null ? item.workshopType : $t('Sem Oficina')
            }}
          </template>
        </v-data-table>
        <div class="pagination">
          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="page"
              :length="totalPages"
              :total-visible="3"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import PieChart from '../../charts/barChart'

export default {
  name: 'OrderByWorkshop',

  components: {
    PieChart,
  },

  props: {
    filterProp: Object,
  },

  created() {
    this.list()
  },

  data() {
    return {
      apiService: new ApiService(),
      chartData: {},
      options: {},
      loading: false,
      workshopTypes: [
        'Engenharia Clínica',
        'Carpintaria',
        'Elétrica',
        'Hidráulica',
        'Climatização',
        'Gasoterapia',
        'Zeladoria',
        'Vidraçaria',
        'Mecânica',
        'Serralheria',
        'Predial Civil',
        'Pintura Predial',
        'Pintura Industrial',
      ],
      headers: [
        {
          text: '',
          value: '',
        },

        {
          text: 'Oficina',
          value: 'workshopType',
          align: 'center',
        },

        {
          text: 'Ordens',
          value: 'orders',
          align: 'center',
        },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      items: [],
      pageSize: 10,
      page: 1,
      totalPages: 0,
      total: 0,
    }
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `request_By_Workshop_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/requestByWorkshop', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    list() {
      this.loading = true
      this.apiService
        .post('reports/orderByWorkshop', this.filterProp)
        .then((response) => {
          this.items = response.content.objects
          this.totalPages = response.content.pager.totalPages

          this.options = {
            legend: {
              display: true,
              responsive: false,
              maintainAspectRatio: true,
              labels: {
                usePointStyle: true,
              },
            },
            plugins: {
              datalabels: {
                display: true,
                color: '#fff',
                anchor: 'center',
                align: 'center',
                font: {
                  weight: 'bold',
                },
                formatter: (value) => {
                  return value > 0 ? value : ''
                },
              },
            },
          }

          this.chartData = {
            labels: this.items.map((x) =>
              this.$t(this.workshopTypes[x.workshopType])
            ),
            datasets: [
              {
                label: this.$t('Oficinas'),
                backgroundColor: this.getBackgroundColors(this.items.length),
                data: this.items.map((x) => x.orders),
                fill: false,
                pointStyle: 'square',
              },
            ],
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    getBackgroundColors(length) {
      const colors = [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ]

      for (let i = 0; i < length; i++) {
        colors.push(`#${Math.floor(Math.random() * 16777215).toString(16)}`)
      }

      return colors
    },
  },

  watch: {
    page() {
      this.filterProp.page = this.page
      this.list()
    },
  },
}
</script>

<style scoped></style>
